import { useState } from 'react';
import type { IRating } from './types';
import { StarButtonContent } from './components/StarButtonContent';
import { RatingsModal } from 'components/RatingsModal';

export const Rating = ({
  ratingValue = 0,
  ratingData,
  ratingMsg,
  settingRateData,
  ratingTotal,
  trackingEvent,
  recipeTitle,
  showCommentField = false,
  showContactPageData = false,
  contactPageData = '',
}: IRating) => {
  const [modalIsOpen, setIsOpen] = useState(false);

  return (
    <div className="align-center">
      <button onClick={() => setIsOpen(true)} className="block w-full" type="button">
        <StarButtonContent
          ratingEn={ratingData.rating_en}
          ratingTotal={ratingTotal}
          ratingValue={ratingValue}
        />
      </button>
      <RatingsModal
        modalIsOpen={modalIsOpen}
        setClose={() => setIsOpen(false)}
        ratingData={ratingData}
        ratingMsg={ratingMsg}
        settingRateData={settingRateData}
        trackingEvent={trackingEvent && trackingEvent}
        recipeTitle={recipeTitle}
        showCommentField={showCommentField}
        showContactPageData={showContactPageData}
        contactPageData={contactPageData}
      />
    </div>
  );
};
